import { CustomerFormValues } from '@/types/customer-form-values';
import { useCurrentOrderQuery } from './queries/use-order-query';

export default function useCustomerFormDefaultValues(): CustomerFormValues {
  const { data: order } = useCurrentOrderQuery();

  if (order && order.customer && order.shippingAddress) {
    return {
      firstName: order.customer.firstName,
      lastName: order.customer.lastName,
      email: order.customer.email,
      mobileNumber: order.customer.mobileNumber,
      street: order.shippingAddress.street,
      city: order.shippingAddress.city,
      postalCode: order.shippingAddress.postalCode,
      country: order.shippingAddress.country,
    };
  }

  return {
    firstName: '',
    lastName: '',
    email: '',
    mobileNumber: '',
    street: '',
    city: '',
    postalCode: '',
    country: 'Sweden',
  };
}
